"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEW_CREDIT_NOTE = void 0;

var _general = require("./general");

var _creditInfo = require("./creditInfo");

var _stockCredit = require("./stockCredit");

var _overview = require("./overview");

var NEW_CREDIT_NOTE = {
  GENERAL: _general.GENERAL,
  CREDIT_INFO: _creditInfo.CREDIT_INFO,
  STOCK_CREDIT: _stockCredit.STOCK_CREDIT,
  OVERVIEW: _overview.OVERVIEW
};
exports.NEW_CREDIT_NOTE = NEW_CREDIT_NOTE;